export const toggleShowingPassword = (isShowPassword, setIsShowPassword) => {
  setIsShowPassword(!isShowPassword);
};
